import { render, staticRenderFns } from "./BackRepository.vue?vue&type=template&id=00299a18&scoped=true"
import script from "./BackRepository.vue?vue&type=script&lang=js"
export * from "./BackRepository.vue?vue&type=script&lang=js"
import style0 from "./BackRepository.vue?vue&type=style&index=0&id=00299a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00299a18",
  null
  
)

export default component.exports